import styled from "styled-components";
import InputBase from "@material-ui/core/InputBase";
import { Grid, Container, Typography } from "@material-ui/core";

export const FilterContainer = styled(Container)`
  flex: 1;
  width: 100%;
  padding-right: 30px;
  padding-left: 30px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 100px;
`;

export const Label = styled.label`
  color: ${(props) => `${props.theme.palette.text.primary} !important`};
  font-size: 10pt;
  font-weight: bold;
  line-height: 12px;
  margin: 10px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

export const DateField = styled(InputBase)`
  background-color: ${(props) =>
    `${props.theme.palette.background.main} !important`};
  border: 0;
  color: #ccc !important;
  font-size: 14px;
`;

export const SnippetSourceList = styled.div`
  height: calc(100% - 115px);
  overflow-y: scroll;
`;

export const CustomPlaceHolder = styled(Grid)`
  background-color: ${(props) => props.theme.palette.background.main};
  border-style: dotted;
  border-color: ${(props) => props.theme.palette.border.main};
  border-width: 3px;
  height: 75px;
  border-radius: 5px;
`;

export const SnippetTitle = styled(Grid)`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  margin: 10px 0;
  a {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: ${(props) => props.theme.palette.text.primary};
  }
  a:hover {
    color: ${(props) => props.theme.palette.text.primary};
    text-decoration: none;
  }
`;

export const SnippetSourceDateCol = styled(Grid)`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  display: flex;
  justify-content: flex-end;
  color: ${(props) => props.theme.palette.text.secondary};
  margin-right: 10px;
  align-items: center;
`;

export const LogoSourceCol = styled(Grid)`
  justify-content: center;
  /* align-self: center; */
  /* align-content: center; */
  margin-top: 10px;
  align-items: flex-start;
  display: flex;
`;

export const SnippetTextCol = styled(Grid)`
  padding-left: 0 !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
`;

export const SnippetButtonCol = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  i:hover {
    color: ${(props) => `${props.theme.palette.primary.main} !important`};
  }
  padding-right: 18px;
`;

export const Paper = styled.div`
  position: relative;
  min-width: 0;
  background-color: ${(props) => props.theme.palette.background.main};
  box-shadow: -1px 6px 6px -2px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 4px;
  height: calc(100vh - 120px);
  padding: 0px 10px;
  overflow: hidden;
`;

export const SubPaper = styled.div`
  position: relative;
  min-width: 0;
  background-color: ${(props) => props.theme.palette.background.main};
  /* box-shadow: -1px 6px 6px -2px rgba(0, 0, 0, 0.1); */
  /* border-bottom-left-radius: 4px; */
  height: calc(100vh - 150px);
  padding: 0px 10px;
  overflow: hidden;
`;

export const PaperBorderBackground = styled.div`
  width: 0;
  height: 0;
  border-right: 52px solid #ad6a6a00;
  border-top: 53px solid ${(props) => props.color};
  position: absolute;
`;
export const OpenPaperIcon = styled.div`
  background: ${(props) => props.theme.palette.background.main};
  /* border: 0.2px solid #a7a7a7; */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  float: right;
  top: 55px;
  position: relative;
  color: ${(props) => props.theme.palette.primary.main};
  width: 54px;
  height: 100%;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  font-size: 35pt;
  text-align: center;
  /* z-index: 10000; */
`;

export const ArticlePaperContainer = styled.div`
  z-index: ${(props) => (props.isEditor ? "0" : "1051 !important")};
  position: relative;
  /* height: 97%; */
  margin-top: 55px;
  flex: 1;
  max-width: 500px;
  box-shadow: rgba(0, 0, 0, 0.1) -5px 6px 6px -2px;
  background-color: white;
`;

export const ArticlePaperHeader = styled(Grid)`
  background-color: ${(props) => props.theme.palette.background.main};
`;

export const SnippetEmptyText = styled(Grid)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  color: ${(props) => props.theme.palette.text.primary};
`;

export const PaperTitle = styled(Grid)`
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  /* text-align: center; */
  margin-bottom: 20px;
  /* margin-top: 20px; */
  font-family: "Roboto";
  color: "#323232";
`;

export const PathText = styled(Typography)`
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 9px;
  margin-bottom: 5px;
  margin-top: 5px;
  font-family: "Roboto";
  color: "#9A9A9A";
`;

export const ArticlePaperSnippets = styled.div`
  overflow-y: auto;
  height: calc(100% - 165px);
`;

export const ArticlePaperActionButtons = styled(Grid)`
  /* padding: 10px 20px 0 0; */
  display: flex;
  font-size: 13pt;
  align-items: center;
`;
